/**
 * @generated SignedSource<<0ebee826c484c8c90a7ff737515203a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastSettingsQuery$variables = {
  id: string;
};
export type StorecastSettingsQuery$data = {
  readonly dashboard: {
    readonly id: string;
    readonly name: string;
    readonly screens: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
  readonly storecast: {
    readonly screens: ReadonlyArray<{
      readonly activeSession: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly name: string;
    }>;
  };
};
export type StorecastSettingsQuery = {
  response: StorecastSettingsQuery$data;
  variables: StorecastSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Storecast",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "screens",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastSession",
            "kind": "LinkedField",
            "name": "activeSession",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Dashboard",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "screens",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastSettingsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastSettingsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "5989152521bfd8763e683b8419fd7043",
    "id": null,
    "metadata": {},
    "name": "StorecastSettingsQuery",
    "operationKind": "query",
    "text": "query StorecastSettingsQuery(\n  $id: ID!\n) {\n  storecast {\n    screens {\n      id\n      name\n      activeSession {\n        id\n      }\n    }\n  }\n  dashboard(id: $id) {\n    id\n    name\n    screens {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1806f0fb2acf61c17df61aebe0208b03";

export default node;
